(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("pixi-layers"));
	else if(typeof define === 'function' && define.amd)
		define("egtLibrary", ["pixi-layers"], factory);
	else if(typeof exports === 'object')
		exports["egtLibrary"] = factory(require("pixi-layers"));
	else
		root["egtLibrary"] = factory(root["pixi-layers"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__48__) {
return 